import classNames from "classnames";

export const useCptUtil_04 = ({ current, $t, dayjs, userTimeZone, isLongText, is_en_gl_link }: any) => {
  const getCpt01 = () => {
    if (isEmptyType(current?.Temperature?.Value)) {
      return null;
    }

    return (
      <p className="h-100 relative text-center center">
        {<WeatherImage className="w-90" src={current?.WeatherIconImg} />}
      </p>
    );
  };

  const getCpt02 = () => {
    if (isEmptyType(current?.Temperature?.Value)) {
      return null;
    }
    return (
      <p className="h-100 relative flex" dir="auto">
        <span className="text-75">{current.Temperature.Value}</span>{" "}
        <span className="text-30 align-top lh-70 font-400">℃</span>
      </p>
    );
  };

  const getCpt03 = () => {
    if (!isEmptyType(current?.Past24HourRange?.Maximum?.Value || current?.Past24HourRange?.Minimum?.Value)) {
      return (
        <p className={classNames(["w-full text-18 pl-15"])}>
          {current.Past24HourRange.Maximum.Value +
            current.Past24HourRange.Maximum.Unit +
            "/" +
            current.Past24HourRange.Minimum.Value +
            current.Past24HourRange.Minimum.Unit}
        </p>
      );
    }
  };
  const getCpt04 = () => {
    if (!isEmptyType(current?.WeatherText)) {
      return <p className="w-full pl-0 text-18 text-center">{current.WeatherText}</p>;
    }
  };
  const getCpt05 = () => {
    if (!isEmptyType(current?.RealFeelTemperature?.Value)) {
      return (
        <>
          <p className="lh-22">
            {$t("title21")} {current.RealFeelTemperature.Value}
            {current?.RealFeelTemperature?.Unit}
          </p>
          <p className="lh-22">|</p>
        </>
      );
    }
  };
  const getCpt06 = () => {
    if (!isEmptyType(current?.RealFeelTemperatureShade?.Value)) {
      return (
        <p className="lh-22">
          {$t("title22")} {current.RealFeelTemperatureShade.Value}
          {current?.RealFeelTemperatureShade?.Unit}
        </p>
      );
    }
  };
  const getCpt07 = () => {
    return (
      <div className={classNames(["flex justify-start items-center w-full gap-x-60"])}>
        <div className={classNames(["overflow-hidden flex flex-col items-center gap-y-8 w-126"])}>
          {getCpt01()}
          {getCpt04()}
        </div>
        <div className="flex flex-col items-center justify-start gap-y-8">
          {getCpt02()}
          {getCpt03()}
        </div>
      </div>
    );
  };
  const getCpt09 = () => {
    return (
      <div className="flex items-center gap-x-8 text-13 font-500">
        {getCpt05()}
        {getCpt06()}
      </div>
    );
  };

  const getCpt10 = () => {
    let formatted = dayjs().tz(userTimeZone).format("HH:mm, DD-MMM");
    let finalText = formatted;
    // 俄语特殊处理
    if (isLongText()) {
      formatted = dayjs().tz(userTimeZone).locale("ru").format("HH:mm, DD MMMM");
      finalText = formatted.replace(/(\s\w)/, (match: any) => match.toUpperCase());
    }
    if (is_en_gl_link()) {
      formatted = dayjs().tz(userTimeZone).format("HH:mm, DD MMM");
      finalText = formatted;
    }
    return (
      <div className={classNames(["w-full flex justify-between items-center"])}>
        <div className="text-16 font-400">{$t("title01")}</div>
        <div className={classNames([" font-400", "text-12"])}>{finalText}</div>
      </div>
    );
  };

  return {
    getCpt01,
    getCpt02,
    getCpt03,
    getCpt04,
    getCpt05,
    getCpt06,
    getCpt07,
    getCpt09,
    getCpt10,
  };
};
